export default "__VITE_ASSET__54c434cd__"